"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TdLink_1 = __importDefault(require("./TdLink"));
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var AppLinkContainer = /** @class */ (function (_super) {
    __extends(AppLinkContainer, _super);
    function AppLinkContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppLinkContainer.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "app-link-container" },
            react_1.default.createElement(TdLink_1.default, { action: "goto-aperza", href: "https://www" + appConfig.baseDomain, anchorText: "Aperza", openOnNewTab: true },
                "Aperza ",
                react_1.default.createElement("i", { className: "fa fa-external-link", "aria-hidden": "true" })),
            appConfig.isAperzaCatalogTop && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null, "|"),
                react_1.default.createElement(TdLink_1.default, { action: "goto-aperza-cloud", href: "https://cloud" + appConfig.baseComDomain + "/home/index.html", anchorText: "Aperza Cloud", openOnNewTab: true },
                    "Aperza Cloud ",
                    react_1.default.createElement("i", { className: "fa fa-external-link", "aria-hidden": "true" }))))));
    };
    return AppLinkContainer;
}(react_1.Component));
exports.default = AppLinkContainer;
